// src/config/badgeConfig.js

import tasteMakerIcon from '../assets/badges/taste_maker.png';
import trendMasterIcon from '../assets/badges/trend_master.png';
import vibeArchitectIcon from '../assets/badges/vibe_architect.png';

export const BADGE_CONFIG = {
  TASTE_MAKER_10: { 
    name: "Taste Maker", 
    icon: tasteMakerIcon 
  }, // ✅ Ensure this comma is here

  TREND_MASTER_100: { 
    name: "Trend Master", 
    icon: trendMasterIcon 
  }, // ✅ And this one

  VIBE_ARCHITECT_1000: { 
    name: "Vibe Architect", 
    icon: vibeArchitectIcon 
  } // No comma needed on the last item
};

export const STREAK_BADGE_HIERARCHY = [
  'VIBE_ARCHITECT_1000',
  'TREND_MASTER_100',
  'TASTE_MAKER_10'
];